import * as React from "react";
import {FormBodyProps} from "../../../common/props/FormBodyProps";
import SectionView from "../../../layout/section/SectionView";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import UtilityForm from "./UtilityForm";

export default class UtilityFormBody extends React.PureComponent<FormBodyProps<UtilityForm>, {}> {
	render() {
		return (
			<SectionView>
				<div className={"c-create-utility"}>
					<InputFormGroup label="Utility name"
									placeholder="Enter name"
									field={this.props.form.name}
									onChange={this.props.onFieldChange}
									focus={this.props.form.hasFocus(this.props.form.name)}/>
				</div>
			</SectionView>
		);
	}
}